/** Product name shown across the platform UI. */
export const APP_NAME = "Maphunziro";
export const APP_TAGLINE = "School Management System";
export const PLATFORM_LOGIN_LABEL = `${APP_NAME} login`;

/** Brand logo (public/); used in UI, favicon, and PWA install icons. */
export const APP_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/logo.png`;
export const APP_ICON_192_SRC = `${process.env.PUBLIC_URL || ""}/icons/icon-192.png`;

/** PWA / browser chrome — matches logo ring blue */
export const APP_THEME_COLOR = "#0f2d5c";

/** Malawi-inspired accents for marketing & install prompts (flag: black, red, green, sun). */
export const MALAWI_BRAND = {
  tagline: "Built for Malawian schools",
  regionLabel: "Malawi",
  colors: {
    black: "#111111",
    red: "#CE1126",
    green: "#218838",
    sun: "#E8C97E",
  },
};
